import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { careReducer } from './care.reducer';
import { CareEffects } from './care.effects';

/**
 * Care feature state module
 * Encapsulates all care-related state management
 */
@NgModule({
  imports: [
    StoreModule.forFeature('care', careReducer),
    EffectsModule.forFeature([CareEffects])
  ]
})
export class CareStateModule {}
